// frontend/src/components/Search/SearchModeSelector.jsx
// Search mode segmented tabs (ToggleButtonGroup)

import { ToggleButtonGroup, ToggleButton } from '@mui/material';

/**
 * Search mode options
 */
const SEARCH_MODES = [
  { value: 'basic', label: '一般搜尋' },
  { value: 'advanced', label: '進階搜尋' },
  { value: 'near', label: '鄰近搜尋' },
];

/**
 * SearchModeSelector - Segmented tabs for selecting search mode
 *
 * @param {string} mode - Current search mode ('basic' | 'advanced' | 'near')
 * @param {Function} onModeChange - Callback when mode changes
 * @param {boolean} disabled - Whether the selector is disabled
 */
const SearchModeSelector = ({ mode, onModeChange, disabled = false }) => {
  const handleChange = (_event, newValue) => {
    // ToggleButtonGroup exclusive 模式允許取消全部選取（newValue = null）
    // 防護：只在有值時觸發
    if (newValue !== null && onModeChange) {
      onModeChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={mode}
      exclusive
      onChange={handleChange}
      disabled={disabled}
      size="small"
      sx={{
        backgroundColor: 'action.hover',
        borderRadius: 2,
        p: '3px',
        '& .MuiToggleButton-root': {
          border: 'none',
          borderRadius: '6px !important',
          px: 2.5,
          py: 0.8,
          fontWeight: 500,
          fontSize: '13.5px',
          color: 'text.secondary',
          textTransform: 'none',
          '&.Mui-selected': {
            backgroundColor: 'background.paper',
            color: 'primary.main',
            fontWeight: 600,
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            '&:hover': {
              backgroundColor: 'background.paper',
            },
          },
          '&:hover': {
            backgroundColor: 'transparent',
          },
        },
      }}
    >
      {SEARCH_MODES.map((option) => (
        <ToggleButton key={option.value} value={option.value}>
          {option.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};

export default SearchModeSelector;
